import React, { Component } from "react"
import { withTranslation } from "react-i18next"
import Typography from "@mui/material/Typography"
import logo from "../assets/logo.svg"

export default withTranslation()(
  class AdminWelcome extends Component {
    render() {
      const { t } = this.props

      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "fixed",
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            backgroundColor: "#E6E2B1",
          }}
        >
          <div
            style={{
              margin: "auto",
              maxHeight: "100%",
              overflow: "auto",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#E6E2B1",
                textAlign: "center",
                padding: "32px 0 16px 0",
              }}
              className="notSelectable"
            >
              <img alt="" src={logo} style={{ marginBottom: "48px" }} />
              <Typography
                variant="h4"
                style={{
                  fontSize: "30px",
                  fontWeight: 600,
                  margin: "0 32px 8px 32px",
                  color: "#181818",
                }}
              >
                {t`Your screen is too small`}
              </Typography>
              <Typography
                variant="h6"
                style={{ fontWeight: 300, margin: "0 32px", color: "#181818" }}
              >{t`Try connecting from a larger device`}</Typography>
            </div>
          </div>
        </div>
      )
    }
  }
)
